module.exports = __webpack_public_path__ + "img/ctwy-2.b7086dbc.jpg";